import { render, staticRenderFns } from "./AccountHolderDisplayName.vue?vue&type=template&id=79e772c6"
import script from "./AccountHolderDisplayName.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDisplayName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports